module.exports = __webpack_public_path__ + "img/email.73f3a9e9.svg";